import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfigService } from '../config/app-config.service';
import { isApiRequest } from './is-api-request';

export const idempotencyInterceptor: HttpInterceptorFn = (req, next) => {
    // Only add Idempotency-Key for state-changing requests to our own API
    // (a custom header on third-party calls triggers CORS preflight failures)
    if (isApiRequest(req.url, inject(AppConfigService).apiOrigins()) && (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH' || req.method === 'DELETE')) {
        // Check if header already exists to avoid overwriting custom ones
        if (!req.headers.has('Idempotency-Key')) {
            const cloned = req.clone({
                setHeaders: {
                    'Idempotency-Key': crypto.randomUUID()
                }
            });
            return next(cloned);
        }
    }

    return next(req);
};
